<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import Footer from './common/Footer'
import VueRouter from 'vue-router'
import { updatePageTitle } from './router'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  watch: {
    '$route.name'() { this.refreshBaseInfo(); },
    '$i18n.locale'() { updatePageTitle(this.$route); }
  },
  methods: {
    refreshBaseInfo() {
      if (document.visibilityState !== 'hidden' && ['home', 'login', 'LegacyHome'].includes(this.$route.name)) {
        return this.getBaseInfo(false);
      }
    },
    getBaseInfo(checkLogin = true){
      if (this._baseInfoRequest) return this._baseInfoRequest;
      this._baseInfoRequest = this.$http({
        method: 'get',
        url: 'base_info',
        data: { _: Date.now() }
      }).then(res=>{
        if (res && Number(res.code) === 200 && res.data && typeof res.data === 'object') {
          this.$store.commit('setBaseInfoValue', res.data);
        }
        if(checkLogin && !localStorage.getItem('token') && !['login', 'register', 'Language'].includes(this.$route.name)){
          return this.$router.push({path:'/Login'}).catch(error => {
            // 仅忽略并发跳转导致的重复导航，保留其他导航错误。
            if(!VueRouter.isNavigationFailure(error, VueRouter.NavigationFailureType.duplicated)){
              throw error;
            }
          });
        }
      }).catch(() => {
        // Keep the last successful configuration during a temporary network failure.
      }).finally(() => { this._baseInfoRequest = null; });
      return this._baseInfoRequest;
    }

  },
  created(){
    this.getBaseInfo();
  },
  mounted() {
    this._baseInfoTimer = window.setInterval(this.refreshBaseInfo, 30000);
    window.addEventListener('focus', this.refreshBaseInfo);
    document.addEventListener('visibilitychange', this.refreshBaseInfo);
  },
  beforeDestroy() {
    window.clearInterval(this._baseInfoTimer);
    window.removeEventListener('focus', this.refreshBaseInfo);
    document.removeEventListener('visibilitychange', this.refreshBaseInfo);
  }
}
</script>

<style>
body .van-toast {
  font-size: 41.04px;
  padding: 30px;
  line-height: 50px;
  width: 230px;
  background: linear-gradient(30deg, #7d76ef, #d63f8c) !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}
</style>
